const navbar = () => {
  $(() => {
    $("body").on("click", ".menu-item .material-symbols-outlined", function () {
      $(this).next(".dropdown-menu").toggleClass("d-none");
    });

    const useHover = $(window).width() > 990 && window.matchMedia("(hover: hover)").matches;

    // Lang switcher: explicit click toggle (iOS Safari doesn't emulate mouseenter on tap)
    $("body").on("click", ".lang_switcher .dropdown-toggle", function (e) {
      if (useHover) return;
      e.stopPropagation();
      $(this).siblings(".dropdown-menu").toggleClass("d-none");
    });
    $(document).on("click touchstart", function (e) {
      if (!$(e.target).closest(".lang_switcher").length) {
        $(".lang_switcher .dropdown-menu").addClass("d-none");
      }
    });

    // Hover only on real pointer devices, otherwise tap triggers mouseenter + click and closes immediately
    if (useHover) {
      $("body").on("mouseenter", ".dropdown", function () {
        $(this).find(".dropdown-menu").removeClass("d-none");
      });
      $("body").on("mouseleave", ".dropdown", function () {
        $(this).find(".dropdown-menu").addClass("d-none");
      });
    }

    const navbarToggler = document.querySelector(".navbar-toggler");
    if (navbarToggler) {
      navbarToggler.addEventListener("click", () => {
        navbarToggler.classList.toggle("collapsed");
        $("#navbarToggler").toggleClass("aperto");
        $("body").toggleClass("noscroll");
      });
    }

    window.addEventListener("scroll", () => {
      var scroll = $(window).scrollTop();
      var header_top = $(".header-top").outerHeight();

      if (scroll > header_top) {
        $("body").addClass("stickyHeader");
      } else {
        $("body").removeClass("stickyHeader");
      }
    });
  });
};

export default navbar;
